import Countly from "./utils/countly";
import { InitFingerprint } from "./utils/CommonoUtils";
import { getUserEmail, getUserId } from "./utils/FPUser";  




// Countly初始化配置
export const initCountly = async () => {

    Countly.q = Countly.q || []; // 确保队列存在
    window.Countly = Countly; // 将Countly对象挂载到window对象上，以便在其他组件中使用
    let endpoint = process.env.VUE_APP_WEB_LOG_ENDPOINT;
    let debug = process.env.VUE_APP_WEB_LOG_DEBUG;
    console.log("endpoint:", endpoint);
    console.log("debug:", debug);
    Countly.init({
      debug: false, // 开发环境开启调试模式,
      url: endpoint,
      logBase: await buildLogBase() // 传递logBase对象,
    });
  
    // 自动跟踪页面浏览
    // Countly.track_pageview();
  
    // 自动跟踪网页点击
    // Countly.track_clicks();
  
    // 自动跟踪链接点击
    // Countly.track_links();
  
    // 自动跟踪表单提交
    // Countly.track_forms();

    return Countly;
};

export const buildLogBase = async () => {
  return {
    "app_name": "familypro",
    "user_id": await getUserId(),
    "user_email": await getUserEmail(),
    "visitor_id": await InitFingerprint(),
    "browser_type": navigator.userAgent,
    "screen_width": window.screen.width,
    "screen_height": window.screen.height,
    "language": navigator.language,
    "user_agent": navigator.userAgent,
    "platform": navigator.platform,
    "timezone": Intl.DateTimeFormat().resolvedOptions().timeZone,
    "referrer": document.referrer,
    // 环境
    "debug": process.env.VUE_APP_WEB_LOG_DEBUG
    // "utm_source": await getUTMParameter(
  }
}

export const addCustmEvent = async (objectName, eventName, eventLocation, properties) => {
  window.Countly.logBase = {
    ...window.Countly.logBase,
    "user_id": await getUserId(),
    "user_email": await getUserEmail()
  }
  window.Countly.q.push(['add_ltc_event', {
    'objectName': objectName, // 事件对象名称
    'eventName': eventName, // 事件名称
    'eventLocation': eventLocation, // 事件发生的页面或位置
    'properties': properties // 自定义属性对象
  }])
}

